import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import EnterMobile from "../forgotpassword/EnterMobile"
import VerifyEmail from "../forgotpassword/VerifyEmail";
import ResetPassword from "../forgotpassword/ResetPassword";

const ResetPasswordFlow: React.FC = () => {
  const [mobile, setMobile] = useState("");
  const [maskedEmail, setMaskedEmail] = useState("");
  const [step, setStep] = useState(1);

  return (
    <>
      {step === 1 && (
        <EnterMobile
          onNext={(m, email) => {
            setMobile(m);
            setMaskedEmail(email);
            setStep(2);
          }}
        />
      )}

      {step === 2 && (
        <VerifyEmail
          mobile={mobile}
          maskedEmail={maskedEmail}
          onSuccess={() => setStep(3)}
        />
      )}
    </>
  );
};

export default ResetPasswordFlow;
